// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"R3-z","subtitle":"S3-z","wrapper":"T3-z","leftArrow":"U3-z","rightArrow":"V3-z"};